import type { BarModel } from './bars.types';
import type { FobModel } from './fob.types';
import type { ProductModel } from './products.types';
import type { PythonModel } from './pythons.types';
import type { RemoteCoolerModel } from './remote-coolers.types';

export interface TapModel {
  id: string;
  position: number;
  name: string;
  tBarNumber: number | null;
  bar: BarModel;
  remoteCooler: RemoteCoolerModel | null;
  lineLength: number | null;
  status: TapStatusType;
  fob: FobModel | null;
  product: ProductModel | null;
  python: PythonModel | null;
  barDefaultPython: PythonModel | null;
  type: TapType;
}

export interface DeleteTapParams {
  tapId: string;
}

export interface CreateUpdateTapParams {
  position: number;
  barId: string | null;
  tBarNumber: number | null;
  remoteCoolerId: string | null;
  productId: string | null;
  fobId: string | null;
  tapId: string | null;
  shiftTaps: boolean | null;
  pythonId: string | null;
  lineLength: number | null;
  status: TapStatusType;
  type: TapType;
}

export interface CreateBulkTapsParams {
  barId: string | null;
  quantity: number;
  pythonId: string | null;
  status: TapStatusType;
  fobId: string | null;
  remoteCoolerId: string | null;
  productId: string | null;
  lineLength: number | null;
  type: TapType;
  tBarNumber: number | null;
}

export interface ListTapsResponse {
  result: TapModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface ListAutoCompleteTapsParams {
  id: string;
  position: number;
  barName: string;
}

export interface ListAutoCompleteTapsResponse {
  result: ListAutoCompleteTapsParams[];
  count: number;
}

export enum TapStatusType {
  IN_CONTRACT = 'In Contract',
  DUMMY = 'Dummy',
  OUT_OF_CONTRACT = 'Out of Contract'
}

export enum TapType {
  DRAUGHT = 'Draught',
  HAND_PUMP = 'Hand Pump',
  WINE = 'Wine',
  COCKTAIL = 'Cocktail',
  NA = 'N/A'
}

export type TapsSortingFields =
  | 'name'
  | 'position'
  | 'status'
  | 'type'
  | 'tBarNumber'
  | 'productName'
  | 'remoteCoolerName'
  | 'lineLength';
